import { FC } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const EXAMPLES = [
  { timing: 'Opens on day 1, open for 10 days', result: 'Open days 1 through 10. It closes when day 11 starts.' },
  {
    timing: 'Opens on day 5, open for 3 days',
    result: 'Open days 5, 6 and 7. For a cohort starting Monday, January 4, that opens Friday, January 8.',
  },
  { timing: 'Opens on day 92, Open for left empty', result: 'Opens on day 92 and never closes.' },
];

/** Explains the schedule editor's two timing fields, with examples, in a tooltip beside the Timepoints heading. */
export const ScheduleTimingHelp: FC = () => (
  <Tooltip
    arrow
    enterTouchDelay={0}
    leaveTouchDelay={15000}
    slotProps={{
      tooltip: {
        sx: { maxWidth: 420, p: 1.5, bgcolor: 'background.paper', border: 1, borderColor: 'divider', boxShadow: 4 },
      },
      arrow: { sx: { color: 'background.paper' } },
    }}
    title={
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="body2" color="text.primary">
          <strong>Opens on day:</strong> the day of the cohort it opens, at midnight Denver time. Day 1 is the
          cohort&apos;s start date.
        </Typography>
        <Typography variant="body2" color="text.primary">
          <strong>Open for:</strong> how many days it stays open, counting the day it opens. Leave it empty if it never
          closes.
        </Typography>
        <Typography variant="body2" color="text.primary">
          <strong>Examples</strong>
        </Typography>
        {EXAMPLES.map((example) => (
          <Typography key={example.timing} variant="body2" color="text.primary">
            {example.timing}: {example.result}
          </Typography>
        ))}
      </Box>
    }
  >
    <IconButton size="small" aria-label="How timepoint timing works">
      <InfoOutlined fontSize="small" />
    </IconButton>
  </Tooltip>
);
